import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import UpdateDate from 'components/shared/Icon/icons/UpdateDate';
import Popover from 'components/shared/Popover';
import { determineRangeStart, extractExtraRanges, findNearestLeftRangeForType } from 'utils/itineraryDetails';
import { SCHEDULE_ITEM_TYPES, SCHEDULE_TYPES } from 'utils/itineraryDetails/constants';

import { UpdatableDatePicker } from '../../DatePicker/UpdatableDatePicker';
import { useChooseFirstDate } from './functions';
import styles from './index.module.css';

function ChooseFirstDate({ className, mountEl }) {
  const {
    scheduleType,
    scheduleItems,
    currentDate,
    isPopupOpen,
    startDate,
    buttonContainerRef,
    disabled,
    openUpdatePopup,
    finallyUpdateDate,
    handleClosePopup,
  } = useChooseFirstDate();

  return (
    <>
      {isPopupOpen && (
        <Popover
          mountEl={mountEl}
          anchorEl={buttonContainerRef.current}
          onClose={handleClosePopup}
          position="left"
          shiftY={20}
          shiftX={-40}
        >
          {scheduleType === SCHEDULE_TYPES.DATES && (
            <div className={styles.popupContainer}>
              <div className={styles.header}>Select a New Start Date</div>
              <UpdatableDatePicker
                range={currentDate.datesRange}
                onChange={finallyUpdateDate}
                getExtraRanges={() => extractExtraRanges(scheduleType, scheduleItems)}
                showStartLabel
                noRange={currentDate.type === SCHEDULE_ITEM_TYPES.OVERNIGHT}
                determineSelectedRangeStart={() => determineRangeStart(scheduleType, scheduleItems, currentDate.id)}
                determineCalendarStartDate={() => {
                  if (currentDate.datesRange.start) {
                    return currentDate.datesRange.start;
                  }
                  const range = findNearestLeftRangeForType(scheduleType, scheduleItems, currentDate);
                  if (!range) return null;
                  return range.start;
                }}
              />
            </div>
          )}
        </Popover>
      )}
      <button
        className={cx(styles.updateDate, className)}
        onClick={openUpdatePopup}
        disabled={disabled}
        ref={buttonContainerRef}
      >
        <Icon
          className={styles.icon}
          component={UpdateDate}
          width="2.4rem"
          height="2.4rem"
          fill="none"
          hide={disabled}
        />
        <div className={styles.dateContainer}>
          <div className={cx(styles.text, disabled && styles.disabled)}>Start Date:</div>
          <div className={cx(styles.date, disabled && styles.disabled)}>{startDate}</div>
        </div>
      </button>
    </>
  );
}
export default ChooseFirstDate;
